import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import googleAnalyticsIcon from "../../../../../../../../public/images/googleAnalyticsIcon.svg";
type Props = {
  title: string;
  subTitle: string;
  buttons: React.ReactNode;
};
export const AnalyticsDialog = ({
  title,
  subTitle,
  buttons
}: Props) => {
  return <Dialog open sx={{
    textAlign: "center"
  }} data-sentry-element="Dialog" data-sentry-component="AnalyticsDialog" data-sentry-source-file="AnalyticsDialog.tsx">
      <DialogTitle sx={{
      p: 6
    }} data-sentry-element="DialogTitle" data-sentry-source-file="AnalyticsDialog.tsx">
        <img src={googleAnalyticsIcon} alt="googleAnalyticsIcon" />
      </DialogTitle>
      <DialogContent sx={{
      pb: 3,
      px: 6
    }} data-sentry-element="DialogContent" data-sentry-source-file="AnalyticsDialog.tsx">
        <Typography variant="h3" fontWeight="600" data-sentry-element="Typography" data-sentry-source-file="AnalyticsDialog.tsx">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" mt={1} data-sentry-element="Typography" data-sentry-source-file="AnalyticsDialog.tsx">
          {subTitle}
        </Typography>
      </DialogContent>
      <DialogActions sx={{
      justifyContent: "center",
      p: 6,
      pt: 0
    }} data-sentry-element="DialogActions" data-sentry-source-file="AnalyticsDialog.tsx">
        {buttons}
      </DialogActions>
    </Dialog>;
};